// src/components/ShareLocationButton.jsx

import React, { useState } from 'react';
import { Button, CircularProgress } from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { getAccurateLocation } from '../utils/geolocation';

export default function ShareLocationButton({ phone }) {
  const [loading, setLoading] = useState(false);

  const handleShare = async () => {
    try {
      setLoading(true);
      const { latitude: lat, longitude: lon, accuracy } =
        await getAccurateLocation(3, 20);

      const text = encodeURIComponent(
        `Mi ubicación actual (±${Math.round(accuracy)}m):\n` +
        `https://www.google.com/maps?q=${lat},${lon}`
      );
      const waUrl = `https://wa.me/${phone}?text=${text}`;
      window.open(waUrl, '_blank');
    } catch (err) {
      console.error(err);
      alert(
        'No se pudo obtener la ubicación con suficiente precisión.\n' +
        'Verifica permisos y señal GPS.'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      variant="contained"
      startIcon={<WhatsAppIcon />}
      onClick={handleShare}
      disabled={loading}
    >
      {loading ? <CircularProgress size={20} /> : 'Compartir ubicación'}
    </Button>
  );
}
